import request from './index.js'

// 查询文章内容
export function GetArticleById (id) {
    return request({
        url: 'api/website/article/getById/' + id,
        method: 'get',
    });
}

// 查询文章列表
export function GetArticleList (data) {
    return request({
        url: 'api/website/article/list',
        method: 'get',
        params: data
    });
}

// 查询首页
export function GetHomeData (data) {
    return request({
        url: 'api/website/home/getHomeData',
        method: 'get',
        params: data
    });
}

// 查询菜单栏目
export function GetMenuList (data) {
    return request({
        url: 'api/website/menu/getList',
        method: 'get',
        params: data
    });
}

// 获取单页菜单数据
export function GetSinglePage (menuId) {
    return request({
        url: 'api/website/home/getSinglePage/' + menuId,
        method: 'get',
        // params: data
    });
}

// 获取钱币赏析列表
export function GetCoinList () {
    return request({
        url: 'api/website/home/getCoinList',
        method: 'get',
        // params: data
    });
}

// 获取代理商列表
export function GetAgentList (data) {
    return request({
        url: 'api/website/home/getAgentList',
        method: 'get',
        params: data
    });
}

// 获取省市区
export function GetSysArea (data) {
    return request({
        url: '/gbca/user/getSysArea',
        method: 'post',
        // headers: {'time': new Date().getTime()},
        // params: data
    });
}

// 获取字典数据
export function GetSysDictData (data) {
    return request({
        url: '/gbca/sys/getSysDictData',
        method: 'post',
        data: data
    });
}

// 新增网站问题反馈
export function AddQuestion (data) {
    return request({
        url: 'api/website/question/add',
        method: 'post',
        data: data
    });
}

// 鉴定查询结果
export function GetRatingInfo (data) {
    return request({
        url: '/gbca/orderCoin/getWebsiteRatingInfo',
        method: 'post',
        data: data
    });
}

// 数据统计
export function GetCountData (data) {
    return request({
        url: '/gbca/orderCoin/countData',
        method: 'post',
        data: data
    });
}

// 获取纲目对应版式的值
export function GetBanshiValueByCoinName (data) {
    return request({
        url: '/gbca/sys/getBanshiValueByCoinName',
        method: 'post',
        data: data
    });
}

// 发票申请查询
export function SearchInvoiceByOrder (data) {
    return request({
        url: '/api/website/home/searchInvoiceByOrder',
        method: 'get',
        params: data
    });
}

// 发票申请保存
export function SaveInvoice (data) {
    return request({
        url: '/api/website/home/saveInvoice',
        method: 'post',
        data: data
    });
}

// 获取底部公司信息
export function GetCompanyBottomById () {
    return request({
        url: '/api/website/company/getById/1',
        method: 'get',
        // params: data
    });
}

// 获取左侧导航信息
export function GetLeftMenuList (id) {
    return request({
        url: '/api/website/home/getLeftMenuList/' + id,
        method: 'get',
        // params: data
    });
}

//查询类别
export function GETCOININFO (data) {
    return request({
        url: 'gbca/sys/getCoinInfo',
        method: 'POST',
        data: data,
        header: {
            'gsToken': data.token
        }
    })
}

//查询评级信息
export function GETRATINGINFO (data) {
    return request({
        url: 'gbca/orderCoin/getRatingInfo',
        method: 'POST',
        data: data,
        header: {
            'gsToken': data.token
        }
    })
}
export function GETRATINGINFOH5 (data) {
    return request({
        url: 'gbca/orderCoin/getRatingInfoH5',
        method: 'POST',
        data: data,
        header: {
            'gsToken': data.token
        }
    })
}


export function GETRECOMMENDWED (data) {
    return request({
        url: 'gbca/sys/getRecommendWed',
        method: 'POST',
        data: data,
        // header: {
        // 	'gsToken': data.token
        // }
    })
}

export function SEARCHCHECKURL (data) { //鉴定查询-验证评级编号加密规则
    return request({
        url: 'gbca/sys/searchCheckUrl',
        method: 'POST',
        data: data,
    })
}

export function ClearHomeRedis () { //清除缓存
    return request({
        url: '/api/website/home/clearHomeRedis',
        method: 'get',
        // data: data,
    })
}

export function GetAgreement (data) { //隐私政策
    return request({
        url: '/gbca/sys/getAgreement',
        method: 'post',
        data: data
        // data: data,
    })
}

export function GetCoinName (data) {
    return request({
        url: '/gbca/sys/getCoinName',
        method: 'post',
        data: data
        // data: data,
    })
}

export function sendAgrement (data) {
    return request({
        url: `/api/website/home/readAgrement/${data.id}`,
        method: 'post',
        data: data
    })
}

export function channelGetCoinInfo (data) {
    return request({
        url: `/channel/v2/index/xianyu/getCoinInfo`,
        method: 'post',
        data: data
    })
}

/**
 * @function 获取手机号
 * @param {string} code
 * @param {string} loginType 2
 * @param {string} ratingCode
 * **/
export function codePhoneApi (data) {
    return request({
        url: '/gbca/orderCoin/getPhoneByWxCode',
        method: 'post',
        data: data
    })
}

/**
 * @function 发送短信验证码
 * @param {string} smsType 3
 * @param {string} phoneNumber
 * **/
export function sendSmsApi (data) {
    return request({
        url: '/gbca/sysSms/sendSms',
        method: 'post',
        data: data
    })
}

/**
 * @function 绑定微信
 * @param {string} ratingCode
 * @param {string} mobile
 * @param {string} code
 * @param {string} unionid
 * **/
export function bindWxApi (data) {
    return request({
        url: '/gbca/orderCoin/insertSearchCoin',
        method: 'post',
        data: data
    })
}


// WEBPACK FOOTER //
// ./src/api/api.js